export default function (impDate) {
  return {
    id: impDate.id,
    title: impDate.Name,
    subheader: impDate.Subheader_Text,
    textURL: impDate.URL,
    endDate: impDate.End_Date,
    calendarDate: new Date(impDate.Start_Date_Date_Only).toISOString(),
    showOnPortal: impDate.Show_On_Portal,
    // kept empty when unset so the calendar can fall back to its own palette
    badgeColor: impDate.Badge_Text_Color || '',
    badgeBgColor: impDate.Badge_Background_Color || '',
    badgeTitle: impDate.Badge_Title,
    isBlackoutEvent: impDate.Is_Blackout_Event || false,
    category: impDate.Category || ''
  };
}
